import React, { useState, useEffect } from 'react';
import { useSessionTimeout, useAppDispatch } from '../hooks';
import { checkSessionExpiration } from '../../store/slices/authSlice';
import { Clock, AlertTriangle } from 'lucide-react';

const SessionTimer = () => {
  const { getFormattedRemainingTime, isSessionActive } = useSessionTimeout();
  const dispatch = useAppDispatch();
  const [remainingTime, setRemainingTime] = useState(null);

  // Actualizar tiempo restante cada segundo
  useEffect(() => {
    if (!isSessionActive) {
      setRemainingTime(null);
      return;
    }

    const updateTimer = () => {
      const time = getFormattedRemainingTime();
      setRemainingTime(time);
      
      // Si la sesión expiró, forzar logout inmediatamente
      if (time === 'Sesión expirada') {
        dispatch(checkSessionExpiration());
      }
    };

    // Actualizar inmediatamente
    updateTimer();

    // Actualizar cada segundo
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [isSessionActive, getFormattedRemainingTime, dispatch]);

  if (!isSessionActive || !remainingTime) {
    return null;
  }

  // Determinar el color basado en el tiempo restante
  const getTimeColor = () => {
    if (!remainingTime || remainingTime === 'Sesión expirada') {
      return 'text-red-600';
    }

    const timeParts = remainingTime.split(':');
    const minutes = parseInt(timeParts[0]);

    if (minutes < 2) {
      return 'text-red-500';
    } else if (minutes < 5) {
      return 'text-yellow-600';
    } else {
      return 'text-green-600';
    }
  };

  const isWarning = remainingTime && remainingTime !== 'Sesión expirada' && 
    parseInt(remainingTime.split(':')[0]) < 2;

  return (
    <div className="fixed top-4 right-4 z-50">
      <div className={`
        flex items-center gap-2 px-3 py-2 rounded-lg shadow-lg
        ${isWarning ? 'bg-yellow-100 border border-yellow-300' : 'bg-blue-100 border border-blue-300'}
      `}>
        {isWarning ? (
          <AlertTriangle className="w-4 h-4 text-yellow-600" />
        ) : (
          <Clock className="w-4 h-4 text-blue-600" />
        )}
        <span className={`text-sm font-medium ${getTimeColor()}`}>
          {remainingTime}
        </span>
      </div>
    </div>
  );
};

export default SessionTimer; 